const ShopActionTypes = {
    FETCH_COLLECTIONS_START: 'UPDATE_COLLECTIONS',
    FETCH_COLLECTIONS_SUCCESS: 'FETCH_COLLECTIONS_SUCCESS',
    FETCH_COLLECTIONS_FAILURE: 'FETCH_COLLECTIONS_FAILURE'
}

export default ShopActionTypes;